<!-- 解除占用 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="[]"  @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="Oddumbers" class="demo-form-inline" size="mini" label-width="100px">
               <el-form-item label="单号">
                <label slot="label" :style="$common.labelStyle('单号')" v-html="'单号'"></label>
                  <el-input class="form_codition" v-model.trim="search" clearable size="mini" placeholder="请输入单号" @keyup.enter.native="submitFun"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="submitFun">查询</el-button>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="relieveAll">一键解除占用</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <el-card class="box-card">
         <div class='page_content'>
            <div class="page_content_center">
               <el-tabs v-model="showTabs" :stretch="false" class="el-tabs--border-card_new" type="card">
                  <el-tab-pane label="解除提取单占用" name="ho">
                     <div style="height: 670px;">
                        <el-table size="mini" id="mxTable" :data="orderList" height="100%" border style="height:100%;width: 500px;margin-top:10px" highlight-current-row>
                           <el-table-column prop="businessCode" label="单号"></el-table-column>
                           <el-table-column prop="opmName" label="占用人"></el-table-column>
                           <el-table-column prop="createTime" label="占用时间">
                              <template slot-scope="{row}">
                                 {{$common.getLocalTime(row.createTime)}}
                              </template>
                           </el-table-column>
                           <el-table-column label="操作" width="105">
                              <template slot-scope="scope">
                                 <el-button type="primary" size="mini" @click="changeFlow(scope.row)">解除占用</el-button>
                              </template>
                           </el-table-column>
                        </el-table>
                     </div>
                  </el-tab-pane>
               </el-tabs>
            </div>
         </div>
      </el-card>
   </div>

</template>
    
    <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import {mock} from "@/api/formList.js"
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {},
   data() {
      var _this = this;
      //这里存放数据
      return {
         requestData: {
            page: 1,
            rows: 30,
            ruleName: "",
            end: "",
            start: "",
         },
         Oddumbers: {},
         selectedDataList: [],
         systemFormList: [],
         classifyInfo: [], //下拉选择规则列表
         classifyId: "",
         settingData: [],
         selectForm: "",
         activeName: "",
         fieldSelectList: [],
         testData: "",
         showTabs: "ho",
         tabHeadIndex: 0,
         pageMsg: {
            //分页信息
            currentPage: 1, //当前页数
            pageSizes: [10, 25, 50, 100], //每页显示个数选择器的选项设置
            pageSize: 10, //每页显示条目个数，支持 .sync 修饰符
            total: 0, //总条目数
         },

         selectedDataIndex: 0, //选择索引
         drawerVisible: false, //弹窗状态控制
         orderList: [],
         search: "",
         initOrderList: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      // 一键解除占用
      relieveAll() {
         this.$confirm("此操作将解除全部占用, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.relieve();
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消",
               });
            });
      },
      async relieve() {
         let relieveDate = await this.$http.deleteAllBillNum();
         console.log(relieveDate);
         if (relieveDate.status == 200) {
            this.$message({
               message: "解除成功",
               type: "success",
            });
            this.getRoules();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 查询
      submitFun() {
         let search = this.search;
         if (search == "") {
            this.orderList = this.initOrderList;
            return;
         }
         let searchData = this.initOrderList.filter(function (product) {
            let searchField = { businessCode: product.businessCode };
            return Object.keys(searchField).some(function (key) {
               return String(product[key]).toLowerCase().indexOf(search.toLowerCase()) > -1;
            });
         });
         console.log(searchData);
         this.orderList = searchData;
      },
      //获取规则菜单列表
      async getRoules() {
         let responseData = await this.$http.queryBillNum();
         // console.log(responseData);
         if (responseData && responseData.status == 200) {
            this.orderList = responseData.result;
            this.initOrderList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      changeFlow(row) {
         this.$confirm("确定解除占用?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.conDel(row);
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消",
               });
            });
      },
      async conDel(row) {
         let params = {
            ids: [row.businessCode],
         };
         let responseData = await this.$http.deleteBillNum(params);
         if (responseData && responseData.status == 200) {
            this.getRoules();
            this.$message({
               message: "解除成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //分页
      handleSizeChange(val) {
         this.pageMsg.pageSize = val;
         this.requestData.rows = val;
         this.getRoules();
      },
      handleCurrentChange(val) {
         this.pageMsg.currentPage = val;
         this.requestData.page = val;
         this.getRoules();
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId],
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            this.getRoules();
            // this.getButtonList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getRoules();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {},
   beforeCreate() {}, //生命周期 - 创建之前
   beforeMount() {}, //生命周期 - 挂载之前
   beforeUpdate() {}, //生命周期 - 更新之前
   updated() {}, //生命周期 - 更新之后
   beforeDestroy() {}, //生命周期 - 销毁之前
   destroyed() {}, //生命周期 - 销毁完成
   activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
    
    <style scoped>
.el-card {
   min-height: 90vh;
   margin: 20px;
}

.el-tabs-box {
   margin-top: 20px;
}

.el-tabs__content {
   height: 90% !important;
   min-height: 70vh;
}

/* .page_content_top_line {
   margin-top: 20px;
} */

.draw {
   padding: 20px;
}

.el-select {
   width: 100%;
}

.block {
   margin-top: 20px;
}
::v-deep .el-tabs__nav .el-tabs__item:nth-child(1) span {
   display: none;
}
.flowBox {
   width: 250px;
   position: relative;
}
.flowCon {
   width: 100%;
   border-radius: 10px;
   background: #efefef;
}
.flowtt {
   width: 100%;
   height: 35px;
   color: #fff;
   border-top-right-radius: 10px;
   border-top-left-radius: 10px;
   line-height: 35px;
   padding-left: 10px;
   background: rgb(45, 97, 240);
}
.flowUser {
   height: 70px;
   padding: 10px;
}
.clo {
   position: absolute;
   top: 8px;
   right: 8px;
   z-index: 999;
   color: #fff;
   font-size: 21px;
}
.flowimg {
   width: 100%;
   text-align: center;
}
.add {
   position: absolute;
   right: 52px;
   bottom: 18px;
   width: 30px;
}
::v-deep .el-input-group__append button.el-button {
   background-color: #409eff;
   color: #fff;
   border-top: 1;
}
</style>
    